const videoGallery = document.querySelector('.sc-video-gallery');

if (videoGallery) {
  // Pagination
  attachEvent('.video-gallery .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('section');
    const pageNumber = ev.target.dataset.page;

    axiosGetRepeaterPaginateItems(parent, pageNumber);
  });
}
